import React, { createContext, useMemo } from "react";

import useWhatsApps from "../../hooks/useWhatsApps";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
  const { loading, whatsApps } = useWhatsApps();

  const syncingWhatsApps = useMemo(
    () => whatsApps.filter(whatsapp => whatsapp.status === "SYNCING"),
    [whatsApps]
  );

  const activeSync = syncingWhatsApps[0] || null;

  const syncInfo = useMemo(() => {
    if (!activeSync) {
      return null;
    }

    const processed = Number(
      activeSync.syncPhaseProcessed ?? activeSync.syncProcessed ?? 0
    );
    const total = Number(activeSync.syncPhaseTotal ?? activeSync.syncTotal ?? 0);
    const percentage =
      total > 0 ? Math.min(100, Math.round((processed / total) * 100)) : null;

    return {
      sessionName: activeSync.name,
      message: activeSync.syncMessage || "Sincronizando dados",
      step: activeSync.syncStep || "sync",
      processed,
      total,
      percentage,
      importedMessages: Number(activeSync.syncImportedMessages || 0),
      importedContacts: Number(activeSync.syncImportedContacts || 0)
    };
  }, [activeSync]);

  return (
    <WhatsAppsContext.Provider
      value={{
        whatsApps,
        loading,
        syncingWhatsApps,
        isSyncing: syncingWhatsApps.length > 0,
        syncInfo
      }}
    >
      {children}
    </WhatsAppsContext.Provider>
  );
};

export { WhatsAppsContext, WhatsAppsProvider };
